import React, {useMemo} from "../../__snowpack__/pkg/react.js";
export const IconCountries = (props) => {
  const {countryCode} = props;
  const renderIcon = useMemo(() => {
    switch (countryCode) {
      case "ID":
        return /* @__PURE__ */ React.createElement(IconCountryID, null);
      case "PH":
        return /* @__PURE__ */ React.createElement(IconCountryPH, null);
      case "TH":
        return /* @__PURE__ */ React.createElement(IconCountryTH, null);
      case "CN":
        return /* @__PURE__ */ React.createElement(IconCountryCN, null);
      case "MY":
        return /* @__PURE__ */ React.createElement(IconCountryMY, null);
      case "VN":
        return /* @__PURE__ */ React.createElement(IconCountryVN, null);
      case "SG":
        return /* @__PURE__ */ React.createElement(IconCountrySG, null);
      case "BR":
        return /* @__PURE__ */ React.createElement(IconCountryBR, null);
      case "TW":
        return /* @__PURE__ */ React.createElement(IconCountryTW, null);
      default:
        return /* @__PURE__ */ React.createElement(React.Fragment, null);
    }
  }, [countryCode]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon);
};
export const IconCountryBR = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    id: "flag-icons-br",
    viewBox: "0 0 640 480"
  }, /* @__PURE__ */ React.createElement("g", {
    "stroke-width": "1pt"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#229e45",
    "fill-rule": "evenodd",
    d: "M0 0h640v480H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#f8e509",
    "fill-rule": "evenodd",
    d: "m321.4 436 301.5-195.7L319.6 44 17.1 240.7 321.4 436z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#2b49a3",
    "fill-rule": "evenodd",
    d: "M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#ffffef",
    "fill-rule": "evenodd",
    d: "m283.3 316.3-4-2.3-4 2 .9-4.5-3.2-3.4 4.5-.5 2.2-4 1.9 4.2 4.4.8-3.3 3m86 26.3-3.9-2.3-4 2 .8-4.5-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.1m-36.2-30-3.4-2-3.5 1.8.8-3.9-2.8-2.9 4-.4 1.8-3.6 1.6 3.7 3.9.7-3 2.7m87-8.5-3.4-2-3.5 1.8.8-3.9-2.7-2.8 3.9-.4 1.8-3.5 1.6 3.6 3.8.7-2.9 2.6m-87.3-22-4-2.2-4 2 .8-4.6-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.2m-104.6-35-4-2.2-4 2 1-4.6-3.3-3.3 4.6-.5 2-4.1 2 4.2 4.4.8-3.3 3.1m13.3 57.2-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.1-4 2 4.2 4.4.8-3.3 3.1m132-67.3-3.6-2-3.6 1.8.8-4-2.8-3 4-.5 1.9-3.6 1.7 3.8 4 .7-3 2.7m-6.7 38.3-2.7-1.6-2.9 1.4.6-3.2-2.2-2.3 3.2-.4 1.5-2.8 1.3 3 3 .5-2.2 2.2m-142.2 50.4-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2M419 299.8l-2.2-1.1-2.2 1 .5-2.3-1.7-1.6 2.4-.3 1.2-2 1 2 2.5.5-1.9 1.5"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#ffffef",
    "fill-rule": "evenodd",
    d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#ffffef",
    "fill-rule": "evenodd",
    d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m42.3 3-2.6-1.4-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .5-2.3 2.1m-4.8 17-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m87.4-22.2-2.6-1.6-2.8 1.4.6-3-2-2.3 3-.3 1.4-2.7 1.2 2.8 3 .5-2.2 2.1m-25.1 3-2.7-1.5-2.7 1.4.6-3-2-2.3 3-.3 1.4-2.8 1.2 2.9 3 .5-2.2 2.1m-68.8-5.8-1.7-1-1.7.8.4-1.9-1.3-1.4 1.9-.2.8-1.7.8 1.8 1.9.3-1.4 1.3m167.8 45.4-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m-20.8 6-2.2-1.4-2.3 1.2.5-2.6-1.7-1.8 2.5-.3 1.2-2.3 1 2.4 2.5.4-1.9 1.8m10.4 2.3-2-1.2-2.1 1 .4-2.3-1.6-1.7 2.3-.3 1.1-2 1 2 2.3.5-1.7 1.6m29.1-22.8-2-1-2 1 .5-2.3-1.6-1.7 2.3-.3 1-2 1 2.1 2.1.4-1.6 1.6m-38.8 41.8-2.5-1.4-2.7 1.2.6-2.8-2-2 3-.3 1.3-2.5 1.2 2.6 3 .5-2.3 1.9m.6 14.2-2.4-1.4-2.4 1.3.6-2.8-1.9-2 2.7-.4 1.2-2.5 1.1 2.6 2.7.5-2 2m-19-23.1-1.9-1.2-2 1 .4-2.2-1.5-1.7 2.2-.2 1-2 1 2 2.2.4-1.6 1.6m-17.8 2.3-2-1.2-2 1 .5-2.2-1.6-1.7 2.3-.2 1-2 1 2 2.1.4-1.6 1.6m-30.4-24.6-2-1.1-2 1 .5-2.3-1.6-1.6 2.2-.3 1-2 1 2 2.2.5-1.6 1.5m3.7 57-1.6-.9-1.8.9.4-2-1.3-1.4 1.9-.2.9-1.7.8 1.8 1.9.3-1.4 1.3m-46.2-86.6-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.2-4 1.9 4.2 4.4.8-3.3 3.1"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    "fill-rule": "evenodd",
    d: "M444.4 285.8a124.6 124.6 0 0 0 5.8-19.8c-67.8-59.5-143.3-90-238.7-83.7a124.5 124.5 0 0 0-8.5 20.9c113-10.8 196 39.2 241.4 82.6z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m414 252.4 2.3 1.3a3.4 3.4 0 0 0-.3 2.2 3 3 0 0 0 1.4 1.7c.7.5 1.4.8 2 .7.6 0 1-.3 1.3-.7a1.3 1.3 0 0 0 .2-.9 2.3 2.3 0 0 0-.5-1c-.2-.3-.7-1-1.5-1.8a7.7 7.7 0 0 1-1.8-3 3.7 3.7 0 0 1 2-4.4 3.8 3.8 0 0 1 2.3-.2 7 7 0 0 1 2.6 1.2c1.4 1 2.3 2 2.6 3.2a4.1 4.1 0 0 1-.6 3.3l-2.4-1.5c.3-.6.4-1.2.2-1.7-.1-.5-.5-1-1.2-1.4a3.2 3.2 0 0 0-1.8-.7 1 1 0 0 0-.9.5c-.2.3-.2.6-.1 1s.6 1.2 1.6 2.2c1 1 1.6 1.9 2 2.5a3.9 3.9 0 0 1-.3 4.2 4.1 4.1 0 0 1-1.9 1.5 4 4 0 0 1-2.4.3c-.9-.2-1.8-.6-2.8-1.3-1.5-1-2.4-2.1-2.7-3.3a5.4 5.4 0 0 1 .6-4zm-11.6-7.6 2.5 1.3a3.4 3.4 0 0 0-.2 2.2 3 3 0 0 0 1.4 1.6c.8.5 1.4.7 2 .6.6 0 1-.3 1.3-.8a1.3 1.3 0 0 0 .2-.8c0-.3-.2-.7-.5-1a34.6 34.6 0 0 0-1.6-1.8c-1.1-1.1-1.8-2-2-2.8a3.7 3.7 0 0 1 .4-3.1 3.6 3.6 0 0 1 1.6-1.4 3.8 3.8 0 0 1 2.2-.3 7 7 0 0 1 2.6 1c1.5 1 2.4 2 2.7 3.1a4.1 4.1 0 0 1-.4 3.4l-2.5-1.4c.3-.7.4-1.2.2-1.7s-.6-1-1.3-1.4a3.2 3.2 0 0 0-1.9-.6 1 1 0 0 0-.8.5c-.2.3-.2.6-.1 1s.7 1.2 1.7 2.2c1 1 1.7 1.8 2 2.4a3.9 3.9 0 0 1 0 4.2 4.2 4.2 0 0 1-1.8 1.6 4 4 0 0 1-2.4.3 8 8 0 0 1-2.9-1.1 6 6 0 0 1-2.8-3.2 5.4 5.4 0 0 1 .4-4zm-14.2-3.8 7.3-12 8.8 5.5-1.2 2-6.4-4-1.6 2.7 6 3.7-1.3 2-6-3.7-2 3.3 6.7 4-1.2 2-9-5.5zm-20.7-17 1.1-2 5.4 2.7-2.5 5c-.8.2-1.8.3-3 .2a9.4 9.4 0 0 1-3.3-1 7.7 7.7 0 0 1-3-2.6 6 6 0 0 1-1-3.5 8.6 8.6 0 0 1 1-3.7 8 8 0 0 1 2.6-3 6.2 6.2 0 0 1 3.6-1.1c1 0 2 .3 3.2 1 1.6.7 2.6 1.7 3.1 2.8a5 5 0 0 1 .3 3.5l-2.7-.8a3 3 0 0 0-.2-2c-.3-.6-.8-1-1.6-1.4a3.8 3.8 0 0 0-3.1-.3c-1 .3-1.9 1.2-2.6 2.6-.7 1.4-1 2.7-.7 3.8a3.7 3.7 0 0 0 2 2.4c.5.3 1.1.5 1.7.5a6 6 0 0 0 1.8 0l.8-1.6-2.9-1.5zm-90.2-22.3 2-14 4.2.7 1.1 9.8 3.9-9 4.2.6-2 13.8-2.7-.4 1.7-10.9-4.4 10.5-2.7-.4-1.1-11.3-1.6 11-2.6-.4zm-14.1-1.7 1.3-14 10.3 1-.2 2.4-7.5-.7-.3 3 7 .7-.3 2.4-7-.7-.3 3.8 7.8.7-.2 2.4-10.6-1z"
  }), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "M216.5 191.3c0-1.5.3-2.6.7-3.6a6.7 6.7 0 0 1 1.4-1.9 5.4 5.4 0 0 1 1.8-1.2c1-.3 2-.5 3-.5 2.1 0 3.7.8 5 2a7.4 7.4 0 0 1 1.6 5.5c0 2.2-.7 4-2 5.3a6.5 6.5 0 0 1-5 1.7 6.6 6.6 0 0 1-4.8-2 7.3 7.3 0 0 1-1.7-5.3z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#f7ffff",
    d: "M219.4 191.3c0 1.5.3 2.7 1 3.6.7.8 1.6 1.3 2.8 1.3a3.5 3.5 0 0 0 2.8-1.1c.7-.8 1-2 1.1-3.7 0-1.6-.2-2.8-1-3.6a3.5 3.5 0 0 0-2.7-1.3 3.6 3.6 0 0 0-2.8 1.2c-.8.8-1.1 2-1.2 3.6z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m233 198.5.2-14h6c1.5 0 2.5.2 3.2.5.7.2 1.2.7 1.6 1.3s.6 1.4.6 2.3a3.8 3.8 0 0 1-1 2.6 4.5 4.5 0 0 1-2.7 1.2l1.5 1.2c.4.4.9 1.2 1.5 2.3l1.7 2.8h-3.4l-2-3.2-1.4-2a2.1 2.1 0 0 0-.9-.6 5 5 0 0 0-1.4-.2h-.6v5.8H233z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "M236 190.5h2c1.4 0 2.3 0 2.6-.2.3 0 .6-.3.8-.5s.3-.7.3-1c0-.6-.1-1-.4-1.2-.2-.3-.6-.5-1-.6h-2l-2.3-.1v3.5z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m249 185.2 5.2.3c1.1 0 2 .1 2.6.3a4.7 4.7 0 0 1 2 1.4 6 6 0 0 1 1.2 2.4c.3.9.4 2 .3 3.3a9.3 9.3 0 0 1-.5 3c-.4 1-1 1.8-1.7 2.4a5 5 0 0 1-2 1c-.6.2-1.5.2-2.5.2l-5.3-.3.7-14z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "m251.7 187.7-.5 9.3h3.8c.5 0 .9-.2 1.2-.5.3-.3.6-.7.8-1.3.2-.6.4-1.5.4-2.6l-.1-2.5a3.2 3.2 0 0 0-.8-1.4 2.7 2.7 0 0 0-1.2-.7 13 13 0 0 0-2.3-.3h-1.3z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m317.6 210.2 3.3-13.6 4.4 1 3.2 1c.7.4 1.3 1 1.6 1.9.4.8.4 1.7.2 2.8-.2.8-.5 1.5-1 2a3.9 3.9 0 0 1-3 1.4c-.7 0-1.7-.2-3-.5l-1.7-.5-1.2 5.2-2.8-.7z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "m323 199.6-.8 3.8 1.5.4c1 .2 1.8.4 2.2.3a1.9 1.9 0 0 0 1.6-1.5c0-.5 0-.9-.2-1.3a2 2 0 0 0-1-.9l-1.9-.5-1.3-.3z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m330.6 214.1 4.7-13.2 5.5 2c1.5.5 2.4 1 3 1.4.5.5.9 1 1 1.8s.2 1.5 0 2.3c-.4 1-1 1.7-1.8 2.2-.8.4-1.8.5-3 .3.4.5.8 1 1 1.6l.8 2.7.6 3.1-3.1-1.1-1-3.6a19.5 19.5 0 0 0-.7-2.4 2.1 2.1 0 0 0-.6-.8c-.2-.3-.6-.5-1.3-.7l-.5-.2-2 5.6-2.6-1z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "m336 207.4 1.9.7c1.3.5 2.1.7 2.5.7.3 0 .6 0 .9-.3.3-.2.5-.5.6-.9.2-.4.2-.8 0-1.2a1.7 1.7 0 0 0-.8-.9l-2-.7-2-.7-1.2 3.3z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "M347 213.6a9 9 0 0 1 1.7-3.2 6.6 6.6 0 0 1 1.8-1.5 6 6 0 0 1 2-.7c1 0 2 0 3.1.4a6.5 6.5 0 0 1 4.2 3.3c.8 1.6.8 3.5.2 5.7a7.4 7.4 0 0 1-3.4 4.5c-1.5.9-3.3 1-5.2.4a6.6 6.6 0 0 1-4.2-3.3 7.3 7.3 0 0 1-.2-5.6z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "M349.8 214.4c-.4 1.5-.5 2.8 0 3.8s1.2 1.6 2.3 2c1 .3 2 .2 3-.4 1-.5 1.6-1.6 2.1-3.2.5-1.5.5-2.7 0-3.7a3.5 3.5 0 0 0-2.2-2 3.6 3.6 0 0 0-3 .3c-1 .6-1.7 1.6-2.2 3.2z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m374.3 233.1 6.4-12.4 5.3 2.7a10 10 0 0 1 2.7 1.9c.5.5.8 1.1.8 1.9s0 1.5-.4 2.2a3.8 3.8 0 0 1-2 2c-1 .2-2 .2-3.1-.2.4.6.6 1.2.8 1.7.2.6.3 1.5.4 2.8l.2 3.2-3-1.5-.4-3.7a20 20 0 0 0-.3-2.5 2 2 0 0 0-.5-1l-1.2-.7-.5-.3-2.7 5.2-2.5-1.3z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "m380.5 227.2 1.9 1c1.2.6 2 1 2.3 1 .3 0 .7 0 1-.2.3-.1.5-.4.7-.8.2-.4.3-.8.2-1.2a2 2 0 0 0-.7-1 23.7 23.7 0 0 0-1.8-1l-2-1-1.6 3.2z"
  })), /* @__PURE__ */ React.createElement("g", {
    "stroke-opacity": ".5"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "M426.1 258.7a8.9 8.9 0 0 1 2.5-2.6 6.6 6.6 0 0 1 2.2-.9 5.5 5.5 0 0 1 2.2 0c1 .2 1.9.6 2.8 1.2a6.6 6.6 0 0 1 3 4.4c.3 1.7-.2 3.6-1.4 5.5a7.3 7.3 0 0 1-4.5 3.3 6.5 6.5 0 0 1-5.2-1.1 6.6 6.6 0 0 1-3-4.4c-.3-1.8.2-3.6 1.4-5.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#fff",
    d: "M428.6 260.3c-1 1.3-1.3 2.5-1.1 3.6a3.6 3.6 0 0 0 1.6 2.5c1 .7 2 .9 3 .6 1-.3 2-1 2.9-2.4.9-1.4 1.3-2.6 1.1-3.6-.1-1-.7-1.9-1.6-2.6s-2-.8-3-.5c-1 .2-2 1-3 2.4z"
  })), /* @__PURE__ */ React.createElement("path", {
    fill: "#309e3a",
    d: "m301.8 204.5 2.3-9.8 7.2 1.7-.3 1.6-5.3-1.2-.5 2.2 4.9 1.1-.4 1.7-4.9-1.2-.6 2.7 5.5 1.3-.4 1.6-7.5-1.7z"
  })));
};
export const IconCountryTW = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tw",
    viewBox: "0 0 640 480"
  }, /* @__PURE__ */ React.createElement("clipPath", {
    id: "a"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M0 0h640v480H0z"
  })), /* @__PURE__ */ React.createElement("g", {
    "clip-path": "url(#a)"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "red",
    d: "M0 0h720v480H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#000095",
    d: "M0 0h360v240H0z"
  }), /* @__PURE__ */ React.createElement("g", {
    fill: "#fff"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "m154 126.9-2.5 9.6 9.4 2.6-1.8-7.1zm46.9 5.1-1.8 7.1 9.4-2.6-2.5-9.6zm-41.8-24-5.1 5.1 1.9 6.9z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m155.9 120-1.9 6.9 5.1 5.1z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m154 113.1-6.9 6.9 6.9 6.9 1.9-6.9zm14 27.8 5.1 5.1 6.9-1.9zm18.9 5.1 9.6 2.5 2.6-9.4-7.1 1.8z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m192 140.9 7.1-1.8 1.8-7.1zm-31.1-1.8 2.6 9.4 9.6-2.5-5.1-5.1zm19.1 5 6.9 1.9 5.1-5.1z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m173.1 146 6.9 6.9 6.9-6.9-6.9-1.9zm-12.2-45.1-9.4 2.6 2.5 9.6 5.1-5.1zm-1.8 31.1 1.8 7.1 7.1 1.8zm45-12 1.9-6.9-5.1-5.1z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m168 99.1-7.1 1.8-1.8 7.1zm32.9 8.9-1.8-7.1-7.1-1.8zm5.1 18.9 6.9-6.9-6.9-6.9-1.9 6.9z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m200.9 108-8.9-8.9-12-3.2-12 3.2-8.9 8.9-3.2 12 3.2 12 8.9 8.9 12 3.2 12-3.2 8.9-8.9 3.2-12z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m200.9 132 5.1-5.1-1.9-6.9zm5.1-18.9 2.5-9.6-9.4-2.6 1.8 7.1zm-6.9-12.2-2.6-9.4-9.6 2.5 5.1 5.1zm-26-6.9-9.6-2.5-2.6 9.4 7.1-1.8zm6.9 1.9-6.9-1.9-5.1 5.1z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m186.9 94-6.9-6.9-6.9 6.9 6.9 1.9z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m192 99.1-5.1-5.1-6.9 1.9zM173.1 146l-9.6 2.5 4.5 16.6 12-12.2zm-5.1 19.1 12 44.9 12-44.9-12-12.2zm-7.1-26-9.4-2.6-4.4 16.4 16.4-4.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m147.1 152.9-12 45.1 32.9-32.9-4.5-16.6zm-12-20.9L102 165.1l45.1-12.2 4.4-16.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m154 126.9-6.9-6.9-12 12 16.4 4.5zm0-13.8-2.5-9.6-16.4 4.5 12 12z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M135.1 108 90 120l45.1 12 12-12zm90 24-16.6 4.5 4.4 16.4 45.1 12.2z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m199.1 139.1-2.6 9.4 16.4 4.4-4.4-16.4zm-12.2 6.9-6.9 6.9 12 12.2 4.5-16.6zm19.1-19.1 2.5 9.6 16.6-4.5-12.2-12z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m192 165.1 33.1 32.9-12.2-45.1-16.4-4.4zm7.1-64.2 9.4 2.6 4.4-16.4-16.4 4.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M225.1 108 258 75.1l-45.1 12-4.4 16.4zm-12.2-20.9L225.1 42 192 75.1l4.5 16.4zm12.2 44.9 44.9-12-44.9-12-12.2 12z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m206 113.1 6.9 6.9 12.2-12-16.6-4.5zm-38-38L135.1 42l12 45.1 16.4 4.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m160.9 100.9 2.6-9.4-16.4-4.4 4.4 16.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m147.1 87.1-45.1-12 33.1 32.9 16.4-4.5zm39.8 6.9 9.6-2.5-4.5-16.4-12 12z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M192 75.1 180 30l-12 45.1 12 12z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "m173.1 94 6.9-6.9-12-12-4.5 16.4z"
  })), /* @__PURE__ */ React.createElement("circle", {
    cx: "180",
    cy: "120",
    r: "51.1",
    fill: "#000095"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: "180",
    cy: "120",
    r: "45.1",
    fill: "#fff"
  })));
};
export const IconCountryID = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "16",
    viewBox: "0 0 24 16"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(1 1)"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    stroke: "#D9D9D9",
    strokeWidth: "0.5",
    d: "M0 0H22V14H0z"
  }), /* @__PURE__ */ React.createElement("g", {
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#CC303C",
    d: "M-1.49213975e-13 -1.49658064e-13L21.9040766 -1.49658064e-13 21.9040766 6.95705522 -1.49213975e-13 6.95705522z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#FFF",
    d: "M-1.49213975e-13 6.9398773L21.9040766 6.9398773 21.9040766 13.8969325 -1.49213975e-13 13.8969325z"
  }))))));
};
export const IconCountrySG = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "23px",
    height: "15px",
    viewBox: "0 0 23 15",
    version: "1.1"
  }, /* @__PURE__ */ React.createElement("title", null, "\u7F16\u7EC4 39"), /* @__PURE__ */ React.createElement("g", {
    id: "\u5546\u54C1\u7BA1\u7406-woocemerce",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-39",
    transform: "translate(0.017848, 0.066713)",
    "fill-rule": "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M0.089312672,13.4855667 L21.6822919,13.4855667 L21.6822919,0.0833584939 L0.089312672,0.0833584939 L0.089312672,13.4855667 Z M21.7608263,13.58558 L21.7608263,13.48558 L21.7608263,13.58558 Z M-5.15143483e-14,13.5689252 L-5.15143483e-14,-2.25597319e-13 L21.7716045,-2.25597319e-13 L21.7716045,13.5689252 L-5.15143483e-14,13.5689252 Z",
    id: "\u5F62\u72B6",
    fill: "#353636"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#E24654",
    points: "0.035739336 0.0333034494 21.7180312 0.0333034494 21.7180312 6.78444928 0.035739336 6.78444928"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0.035739336,6.78444928 L21.7180312,6.78444928 L21.7180312,13.5355818 L0.035739336,13.5355818 L0.035739336,6.78444928 Z M3.30414085,3.41721887 C3.30414085,2.35036331 3.98283155,1.43353972 4.94728,1.00012882 C4.75082066,0.966798736 4.55436132,0.933455339 4.35790197,0.933455339 C2.89335963,0.933455339 1.69672676,2.05031268 1.69672676,3.41720555 C1.69672676,4.78409843 2.89335963,5.88429739 4.34002517,5.88429739 C4.53648452,5.88429739 4.75082066,5.86762569 4.9294032,5.81761059 C3.98283155,5.40087139 3.30414085,4.48406112 3.30414085,3.41720555 L3.30414085,3.41721887 Z M6.17962367,1.41688134 L6.34037221,1.85027893 L6.84045184,1.85027893 L6.42967062,2.13365786 L6.59040489,2.56706876 L6.17962367,2.30034821 L5.78670498,2.56706876 L5.92959099,2.13365786 L5.5366723,1.85027893 L6.03673766,1.85027893 L6.17962367,1.41688134 Z M7.66202855,2.43370849 L7.82276283,2.88379109 L8.32284246,2.88379109 L7.91206123,3.15049832 L8.07280978,3.60058093 L7.66202855,3.31718868 L7.25123306,3.60056761 L7.41198161,3.15048501 L7.00120038,2.88379109 L7.50128001,2.88379109 L7.66202855,2.43370849 Z",
    id: "\u5F62\u72B6",
    fill: "#FFFFFF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M4.67937052,2.43370849 L4.84011907,2.88379109 L5.34019869,2.88379109 L4.92941747,3.15049832 L5.09015175,3.60058093 L4.67937052,3.31718868 L4.28645184,3.60056761 L4.44718611,3.15048501 L4.03640489,2.88379109 L4.53649878,2.88379109 L4.67937052,2.43370849 Z M7.09049879,4.08399361 L7.25123306,4.5173912 L7.75132696,4.5173912 L7.34054574,4.80077013 L7.50128001,5.23418103 L7.09049879,4.96746048 L6.6975801,5.23418103 L6.84045184,4.80077013 L6.44753315,4.51740451 L6.94761278,4.51740451 L7.09049879,4.08399361 Z M5.26876282,4.08399361 L5.41163456,4.5173912 L5.91172846,4.5173912 L5.51880977,4.80077013 L5.66168151,5.23418103 L5.26876282,4.96746048 L4.8579816,5.23418103 L5.01871588,4.80077013 L4.60793465,4.51740451 L5.10801428,4.51740451 L5.26876282,4.08399361 Z",
    id: "\u5F62\u72B6",
    fill: "#FFFFFF"
  }))));
};
export const IconCountryTH = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("title", null, "\u6CF0\u56FDThailand"), /* @__PURE__ */ React.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ React.createElement("g", {
    id: "sea-\u591A\u56FD\u5BB6\u9700\u6C42",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-39",
    "fill-rule": "nonzero"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u6CF0\u56FD"
  }, /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#CF0F15",
    points: "0 0 21.8297896 0 21.8297896 13.4095121 0 13.4095121 0 1.81992222"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF",
    points: "0 1.97957922 21.8297896 1.97957922 21.8297896 11.4621995 0 11.4621995"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#00247D",
    points: "0 4.02285363 21.8297896 4.02285363 21.8297896 9.38665847 0 9.38665847"
  })))));
};
export const IconCountryPH = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "14",
    viewBox: "0 0 22 14"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /* @__PURE__ */ React.createElement("g", {
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    fill: "#353636",
    d: "M.09 13.56h21.713V.085H.09V13.56zm21.81.1v-.1.1zM0 13.645V0h21.893v13.644H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#0053A3",
    d: "M0.0538793223 0.0335249117L21.856731 0.0335249117 21.856731 6.82223957 0.0538793223 6.82223957z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#CC303C",
    d: "M0.0538793223 6.82223957L21.856731 6.82223957 21.856731 13.6109542 0.0538793223 13.6109542z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#FFF",
    d: "M0.0538793223 13.6109009L0.0538793223 0.0334449635 10.5781927 6.82215963z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#FAD400",
    d: "M1.527 12.32l-.521-.218-.36.403.054-.52-.52-.201.556-.117.036-.52.288.452.556-.134-.377.403.288.452zm4.256-5.196l.233-.235-.323-.234c-.233.033-.485.05-.718.083-.234.034-.216-.067 0-.1.215-.034.413-.067.628-.1-.143-.118-.161-.152-.34-.101-.198.05-.468.218-.54.016-.054-.134-.161-.184-.018-.251.108-.05.216-.117.324-.168.197-.1.197-.1.233-.318l-.485.302-.215.134c-.108.067 0-.118.018-.134.197-.151.395-.285.592-.436.144-.1.09-.235.09-.386l-.395.017-.449.52c-.144.184-.215.1-.072-.084.126-.168.252-.319.377-.486-.18.017-.215 0-.305.15-.072.101-.126.202-.198.302-.09.134-.035.134-.197.05-.144-.066-.287-.016-.252-.184.036-.117.072-.218.09-.335.054-.201.054-.201-.09-.386-.035.185-.071.352-.107.537l-.054.251c-.018.118-.09-.084-.09-.117.036-.235.054-.47.09-.704.018-.168-.108-.218-.234-.335l-.251.318c.036.218.054.453.09.67.036.219-.072.202-.108 0-.036-.2-.072-.385-.108-.586-.108.134-.161.15-.108.318.036.118.072.218.09.336.036.15.072.117-.09.184-.143.05-.215.168-.305.034-.054-.1-.126-.202-.18-.302-.107-.184-.125-.184-.34-.201.107.15.215.285.34.436l.144.2c.072.101-.125 0-.143-.016l-.485-.553c-.108-.134-.252-.084-.413-.067l.053.385c.198.134.378.268.575.403.198.134.108.2-.072.067-.18-.118-.34-.218-.52-.336.017.168 0 .202.161.285.18.1.503.151.395.352-.072.134-.018.252-.18.218-.125-.033-.233-.067-.359-.084-.269-.067-.269-.067-.449.068.198.033.378.067.575.1l.252.034c.143.016-.09.083-.126.083-.252-.016-.503-.05-.754-.067-.18-.016-.234.1-.36.218l.324.235c.233-.034.485-.05.718-.084.234-.033.216.067 0 .1-.215.034-.413.068-.629.101.144.1.162.151.342.1.197-.05.467-.217.539-.016.053.134.161.184.035.268-.107.05-.215.118-.323.168-.197.1-.197.1-.233.318l.485-.301.215-.134c.108-.067 0 .117-.018.134-.197.15-.395.301-.593.435-.143.101-.09.235-.071.386l.413-.05c.143-.185.305-.352.449-.537.143-.184.215-.1.072.084-.126.168-.252.319-.36.486.18-.017.216 0 .306-.15.071-.101.125-.202.18-.302.089-.134.035-.134.197-.067.143.067.287.016.233.167-.036.118-.072.218-.09.336-.053.2-.053.217.09.385.036-.184.072-.352.108-.536l.036-.235c.018-.134.09.084.09.117-.018.235-.054.47-.072.704-.018.168.108.218.251.319l.252-.302a8.573 8.573 0 01-.09-.67c-.036-.218.072-.202.108 0 .036.2.072.385.125.586.108-.134.144-.15.108-.318-.036-.118-.072-.218-.108-.335-.035-.151-.071-.118.09-.185.144-.05.216-.167.288-.033.071.1.125.2.197.301.126.185.126.185.36.201a7.227 7.227 0 00-.342-.435l-.144-.201c-.071-.101.126 0 .144.016l.485.553c.108.135.251.067.413.067l-.072-.335c-.197-.134-.377-.268-.574-.402-.198-.134-.108-.184.071-.067.18.117.36.218.521.335-.018-.167 0-.201-.161-.285-.18-.1-.503-.15-.396-.352.072-.117.018-.251.18-.2.126.033.234.066.36.083.215.05.215.05.412-.084-.161-.033-.323-.05-.485-.084l-.269-.05c-.036 0-.18-.117-.054-.1l.97.1zm2.389.117l.323-.419-.323-.419.52.168.324-.436v.52l.538.167-.52.151v.536l-.342-.435-.52.167zM1.527 1.324l-.521.218-.36-.402.054.52-.52.217.556.1.036.52.288-.452.556.117-.377-.385.288-.453z"
  })))));
};
export const IconCountryCN = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "14",
    viewBox: "0 0 22 14"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /* @__PURE__ */ React.createElement("g", {
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    fill: "#CC2229",
    d: "M0 0L22 0 22 13.9514058 0 13.9514058z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#FFF22D",
    d: "M2.67 5.12l.337-1.044-.858-.657h1.056l.322-.95.316.95h1.092l-.865.657.323 1.008-.866-.614-.858.65zm2.566-3.199l.257-.402-.294-.38.455.125.242-.358.022.43.462.118-.44.182.022.46-.293-.35-.433.175zm1.525 1.556l-.088-.468-.462-.073.404-.219-.066-.43.308.299.418-.22-.184.432.323.321-.455-.058-.198.416zm0 1.855l-.088-.475-.462-.073.404-.219-.066-.423.308.292.418-.212-.184.424.323.328-.455-.058-.198.416zM5.742 6.691l-.088-.475-.47-.073.411-.22L5.53 5.5l.308.292.411-.211-.183.423.33.329-.455-.059-.198.417z"
  })))));
};
export const IconCountryMY = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "14",
    viewBox: "0 0 22 14"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u5546\u54C1\u7BA1\u7406-woocemerce",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-38",
    transform: "translate(0.017977, 0.016712)",
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M0.089455344,13.5354353 L21.7353658,13.5354353 L21.7353658,0.100336462 L0.089455344,0.100336462 L0.089455344,13.5354353 Z M21.8140429,13.618737 L21.8140429,13.518737 L21.8140429,13.618737 Z M1.42108547e-14,13.6189935 L1.42108547e-14,-1.41220369e-13 L21.8248212,-1.41220369e-13 L21.8248212,13.6022153 L1.42108547e-14,13.6022153 L1.42108547e-14,13.6189935 Z",
    id: "\u5F62\u72B6",
    fill: "#353636"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF",
    points: "0.035739336 9.40792484 21.7711052 9.40792484 21.7711052 10.4439671 0.035739336 10.4439671"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0.035739336,8.37186931 L21.7711052,8.37186931 L21.7711052,9.40792484 L0.035739336,9.40792484 L0.035739336,8.37186931 Z M0.035739336,12.5327498 L21.7711052,12.5327498 L21.7711052,13.568792 L0.035739336,13.568792 L0.035739336,12.5327498 Z",
    id: "\u5F62\u72B6",
    fill: "#D64634"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF",
    points: "0.035739336 7.31912877 21.7711052 7.31912877 21.7711052 8.35517098 0.035739336 8.35517098"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#D64634",
    points: "0.035739336 10.4439671 21.7711052 10.4439671 21.7711052 11.4800093 0.035739336 11.4800093"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0.035739336,11.4967076 L21.7711052,11.4967076 L21.7711052,12.5327498 L0.035739336,12.5327498 L0.035739336,11.4967076 Z M0.035739336,3.15824827 L21.7711052,3.15824827 L21.7711052,4.19429048 L0.035739336,4.19429048 L0.035739336,3.15824827 Z",
    id: "\u5F62\u72B6",
    fill: "#FFFFFF"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#D64634",
    points: "0.035739336 6.28308655 21.7711052 6.28308655 21.7711052 7.31912877 0.035739336 7.31912877"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF",
    points: "0.035739336 1.08617715 21.7711052 1.08617715 21.7711052 2.12220605 0.035739336 2.12220605"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0.035739336,2.12220605 L21.7711052,2.12220605 L21.7711052,3.15824827 L0.035739336,3.15824827 L0.035739336,2.12220605 Z M0.035739336,0.0501349408 L21.7711052,0.0501349408 L21.7711052,1.08617715 L0.035739336,1.08617715 L0.035739336,0.0501349408 Z",
    id: "\u5F62\u72B6",
    fill: "#D64634"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF",
    points: "0.035739336 5.24704434 21.7711052 5.24704434 21.7711052 6.28308655 0.035739336 6.28308655"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#D64634",
    points: "0.035739336 4.21100213 21.7711052 4.21100213 21.7711052 5.24704434 0.035739336 5.24704434"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#0050A2",
    points: "0.035739336 0.0501349408 10.9034223 0.0501349408 10.9034223 8.37186931 0.035739336 8.37186931"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M4.92351085,6.53374794 C3.54489985,6.53374794 2.43486889,5.49770573 2.43486889,4.21100213 C2.43486889,2.92429852 3.54489985,1.88826963 4.92349658,1.88826963 C5.33530504,1.88826963 5.71128856,1.97181455 6.05147568,2.1389177 C5.56804588,1.78799975 4.97722686,1.58748661 4.31477223,1.58748661 C2.7571364,1.58748661 1.50384848,2.75720869 1.50384848,4.21101544 C1.50384848,5.6648222 2.7571364,6.83453095 4.31478649,6.83453095 C4.95933579,6.83453095 5.56806014,6.63400451 6.05147568,6.28308655 C5.71130283,6.43347806 5.33531931,6.53374794 4.92351085,6.53374794 L4.92351085,6.53374794 Z",
    id: "\u8DEF\u5F84",
    fill: "#FCD300"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FCD300",
    points: "7.14358704 2.00523784 7.34056 3.39219801 8.18203946 2.22247593 7.71654352 3.55930116 8.98772251 2.84076692 7.96718969 3.84337253 9.45321844 3.72640431 8.05671637 4.21100213 9.45321844 4.69559994 7.96718969 4.57863173 8.98772251 5.58125065 7.71654352 4.86271641 8.18203946 6.19954163 7.34056 5.02980625 7.14361557 6.41676641 6.94667115 5.02980625 6.12308276 6.19954163 6.58859296 4.86268978 5.29950864 5.58123733 6.33793252 4.57861841 4.85190377 4.69558662 6.24842011 4.21098881 4.85190377 3.726391 6.33793252 3.84335921 5.29950864 2.84074029 6.58859296 3.55928784 6.12308276 2.22246262 6.94665688 3.39219801"
  }))));
};
export const IconCountryVN = () => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "14",
    viewBox: "0 0 22 14"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u5546\u54C1\u7BA1\u7406-woocemerce",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4-40",
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FE0000",
    points: "-7.81597009e-14 -1.7408297e-13 22.0000256 -1.7408297e-13 22.0000256 13.6889115 -7.81597009e-14 13.6889115"
  }), /* @__PURE__ */ React.createElement("polygon", {
    id: "\u8DEF\u5F84",
    fill: "#FFFF00",
    points: "11.0822315 3 12.3435656 5.38529835 15.1644673 5.76744739 13.1233548 7.62457525 13.6049104 10.2482731 11.0822337 9.01056884 8.55955689 10.2482731 9.04111253 7.62457525 7 5.76744739 9.81967711 5.38529835"
  }))));
};
